import api from '@/api';

class ClientFile {
  static getResourceEndpoint(clientId) {
    return `/clients/${clientId}/files`;
  }
  static getResourceIdEndpoint(clientId, fileId) {
    return `${this.getResourceEndpoint(clientId)}/${fileId}`;
  }
  static get(clientId, fileId) {
    return api.get(this.getResourceIdEndpoint(clientId, fileId));
  }
  static list(clientId) {
    return api.get(this.getResourceEndpoint(clientId));
  }
  static create(clientId, params) {
    return api.post(this.getCreateUrl(clientId), params);
  }
  static update(clientId, fileId, params) {
    return api.put(this.getResourceIdEndpoint(clientId, fileId), params);
  }
  static delete(clientId, fileId) {
    return api.delete(this.getResourceIdEndpoint(clientId, fileId));
  }

  /**
   *
   * @param clientId
   * @returns {string}
   */
  static getCreateUrl(clientId) {
    return this.getResourceEndpoint(clientId);
  }
}

export default ClientFile;
